import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Plus = createSvgIcon(React.createElement("polygon", { points: "13,6 11,6 11,11 6,11 6,13 11,13 11,18 13,18 13,13 18,13 18,11 13,11 " }), 'Plus');
export default Plus;
